import React, { Fragment } from 'react';

import Text from '@lightspeed/cirrus-text';
import { colors } from '@lightspeed/cirrus-tokens';
import { Button } from '@lightspeed/flame/Button';
import { Divider } from '@lightspeed/flame/Divider';
import { IconPrinters } from '@lightspeed/flame/Icon/Printers';
import PropTypes from 'prop-types';

import Decimal from 'app/src/data/base/Decimal';
import Format from 'app/src/data/Format';

import { TransactionState } from './ManualPaymentTypes';

class ManualPaymentBodySupplemental extends React.Component {
  constructor(props) {
    super(props);

    this.printReceipt = this.printReceipt.bind(this);
  }

  /**
   * Prints the receipt for the last failed/cancelled transaction.
   */
  printReceipt() {
    const { payment } = this.props;
    window.merchantos.print.printUrl({
      url: `/API/Account/${window.merchantos.session.getSystemCustomerID()}/DisplayTemplate/SalePayment/${payment.model.get(
        'salePaymentID'
      )}.html?template=SalePayment&print=1&page_width=auto&page_height=2000mm`,
      pageType: 'receipt',
    });
  }

  render() {
    const { transactionState, payment, amount, balance } = this.props;
    const { colorsMap } = colors;

    switch (transactionState) {
      case TransactionState.WAITING_TO_START:
        return (
          <Fragment>
            <Divider className="cr-mt-4" />
            <div className="cr-flex cr-justify-between cr-pt-4">
              <label>Balance</label>
              <div>{Format.formatMoney(balance)}</div>
            </div>
          </Fragment>
        );

      case TransactionState.IN_PROGRESS:
        return (
          <div className="quick-pay-modal__body__footer quick-pay-modal__body__footer--centered">
            <Text heading2 className="quick-pay-modal__body__footer--total">
              {Format.formatMoney(amount, 0)}
            </Text>
          </div>
        );

      case TransactionState.COMPLETE:
        const isPartiallyApproved = !payment.amount.isEqualTo(amount);
        return (
          <div className="quick-pay-modal__body__footer quick-pay-modal__body__footer--centered">
            {isPartiallyApproved && (
              <div className="quick-pay-modal__body__footer--strikethrough">
                {Format.formatMoney(amount, 0)}
              </div>
            )}
            <Text heading2 className="quick-pay-modal__body__footer--total">
              {Format.formatMoney(payment.amount, 0)}
            </Text>
          </div>
        );

      case TransactionState.FAILED:
      case TransactionState.CANCELED:
      case TransactionState.DECLINED:
      case TransactionState.ERROR:
        return (
          <div className="quick-pay-modal__body__footer quick-pay-modal__body__footer--centered">
            <Button onClick={this.printReceipt}>
              <IconPrinters color={colorsMap['gray-200']} />
              <span>Print Receipt</span>
            </Button>
          </div>
        );

      case TransactionState.CANCEL_FROM_TERMINAL:
        return (
          <div className="quick-pay-modal__body__footer quick-pay-modal__body__footer--centered">
            Payment must be canceled on the terminal.
          </div>
        );

      default:
        return null;
    }
  }
}

ManualPaymentBodySupplemental.propTypes = {
  transactionState: PropTypes.string.isRequired,
  payment: PropTypes.shape(PropTypes.any.object),
  amount: PropTypes.instanceOf(Decimal).isRequired,
  balance: PropTypes.instanceOf(Decimal).isRequired,
};

ManualPaymentBodySupplemental.defaultProps = {
  payment: null,
};

export default ManualPaymentBodySupplemental;
